<div class="new-user-queue">
    <div class="queue-title-line">
        <h1>{{localize(langSection.AddUserPage, langText.NewUserQueue)}}</h1>
        <div class="listed-entries-display">
            @if (queueErrorService.errorEntries.length !== 0) {
<span class="attention-needed-entries">
                {{queueErrorService.errorEntries.length}} 
                {{queueErrorService.errorEntries.length === 1 ? 
                    localize(langSection.AddUserPage, langText.EntryNeedsAttention) : 
                    localize(langSection.AddUserPage, langText.EntriesNeedAttention)}}
            </span>
}
            <span>{{locations.length}} {{localize(langSection.Term,
                langText.Locations).toLowerCase()}}</span>/<span>{{totalUsers}} {{localize(langSection.AddUserPage,
                langText.EntriesListed)}}</span>
        </div>
    </div>
    <ul class="user-queue-list">
        @for (location of locations; track location) {
<li>
            <new-user-queue-location [locationUserListChange]="locationUserListChange" [syncUsers]="syncUsers" [location]="location">
            </new-user-queue-location>
        </li>
}
    </ul>
</div>